import gemImage from "../assets/images/gem.png"
import StoreItem from "./StoreItem"


export default function Store() {
    return (
        <div className={"relative flex flex-col my-8 items-center"}>
            <div className={'font-pixellari text-white'}>The NOTHING Store</div>
            <div className={'grid grid-cols-2'}>
                <StoreItem price={1} description={"A pouch of nothing"}/>
                <StoreItem price={10} description={"A chest filled with nothing"}/>
                <StoreItem price={100} description={"A vault bursting with nothing"}/>
            </div>
        </div>
    )
}